<div
  class="section-row"
  [class.is-selected]="isSelected()"
  [class.is-hovered]="isHovered()"
  (click)="onRowClick($event)"
  (contextmenu)="onRowContextMenu($event)"
  (mousedown)="onRowMouseDown($event)"
  (mouseenter)="sectionEditorService.hoveredSectionId.set(section().id)"
  (mouseleave)="sectionEditorService.hoveredSectionId.set(undefined)"
  [cdkDragBoundary]="dragBoundaryClass() || ''"
  cdkDrag
>
  <kin-icon
    [color]="isSelected() ? this.colorService.textColor() : this.colorService.neutral500()"
    class="handler"
    name="draggable"
    cdkDragHandle
  />
  <div class="time">
    <input
      type="number"
      name="minutes"
      id="minutes"
      min="0"
      [value]="section().duration.minutes.toString().padStart(2, '0')"
      (change)="onTimeChange('minutes', $event.target)"
    />
    <p>:</p>
    <input
      type="number"
      name="seconds"
      id="seconds"
      step="5"
      [min]="section().duration.minutes === 0 ? minDurationSeconds : null"
      [value]="section().duration.seconds.toString().padStart(2, '0')"
      (change)="onTimeChange('seconds', $event.target)"
    />
  </div>
  @for (sectionData of sectionDatas; track $index) {
    <div class="data">
      <kin-icon
        [color]="isSelected() ? this.colorService.textColor() : this.colorService.neutral500()"
        [name]="sectionEditorService.getWorkoutModeIcon(sectionData.type)"
      />
      <label class="value-field">
        <input
          [style.width.ch]="fieldWidth(sectionData.type)"
          type="number"
          name="data"
          id="data"
          [value]="sectionData.value"
          [min]="sectionEditorService.fieldBounds(sectionData.type).min"
          [max]="sectionEditorService.fieldBounds(sectionData.type).max"
          [step]="sectionEditorService.fieldBounds(sectionData.type).step"
          (change)="onDataChange(sectionData.type, $event.target.value)"
        />
        <span class="unit">{{ sectionEditorService.getWorkoutModeUnit(sectionData.type) }}</span>
      </label>
    </div>
  }
  @if (section().cadence !== undefined) {
    <div class="data cadence">
      <kin-icon
        [color]="isSelected() ? this.colorService.textColor() : this.colorService.neutral500()"
        name="cadence"
      />
      <label class="value-field">
        <input
          [style.width.ch]="cadenceWidth"
          type="number"
          name="cadence"
          [value]="section().cadence"
          [min]="cadenceBounds.min"
          [max]="cadenceBounds.max"
          [step]="cadenceBounds.step"
          (change)="onCadenceChange($event.target.value)"
          (blur)="onCadenceBlur($event.target.value)"
        />
        <span class="unit">RPM</span>
      </label>
    </div>
  } @else if (sectionEditorService.canHaveCadence(mode())) {
    <button type="button" class="add-data" (click)="addCadence()">
      <kin-icon [color]="colorService.brandSecondary()" name="add_circle" />
      <p>{{ 'sections_editor.add_optimal_cadence' | translate }}</p>
    </button>
  }
  <div class="actions">
    <button
      class="duplicate"
      [style.outline-color]="
        isSelected() ? this.colorService.textColor() : this.colorService.neutral100()
      "
      (click)="duplicate.emit(section())"
    >
      <kin-icon name="duplicate" [size]="18" />
    </button>
    <button (click)="delete.emit()" class="delete">
      <kin-icon [color]="colorService.backgroundColor()" [size]="18" name="trash" />
    </button>
  </div>
</div>
